module.exports = __webpack_public_path__ + "static/media/25import.e94c702b.xlsx";